<template>
	<div class="row">
		<div v-if="ratingData" class="col-auto pr-0">
			<div class="d-block text-right">
				<div class="feedback-stars-average feedback-category-view" id="feedback-stars-average">
					<div class="feedback-stars-background clearfix">
						<div class="feedback-star"><i class="fa fa-star"></i></div>
						<div class="feedback-star"><i class="fa fa-star"></i></div>
						<div class="feedback-star"><i class="fa fa-star"></i></div>
						<div class="feedback-star"><i class="fa fa-star"></i></div>
						<div class="feedback-star"><i class="fa fa-star"></i></div>
					</div>
					<div class="feedback-stars-overlay-wrap" id="rating-percent" :style="'width:' + ratingPercent + '%'">
						<div class="feedback-stars-overlay clearfix">
							<div class="feedback-star"><i class="fa fa-star"></i></div>
							<div class="feedback-star"><i class="fa fa-star"></i></div>
							<div class="feedback-star"><i class="fa fa-star"></i></div>
							<div class="feedback-star"><i class="fa fa-star"></i></div>
							<div class="feedback-star"><i class="fa fa-star"></i></div>
						</div>
					</div>
				</div>
			</div>
			<div class="d-block text-right">
				<small class="d-block" id="rating">{{ rating }}</small>
				<small class="d-block" id="rating-count">{{ ratingCount }}</small>
			</div>
		</div>

		<div class="col pr-0 d-flex align-self-center">
			<img class="img-fluid shopvote-badge-header" :src="bannerSrc" alt="Shopvote Sigil" />
		</div>
	</div>
</template>

<script>
import ApiService from "../../../ceres/services/ApiService";
import TranslationService from "../../../ceres/services/TranslationService";

export default {
    name: "shop-vote-badge",

	props: {
		shopId: {
			type: Number,
			required: true
		}
	},

	data() {
		return {
			ratingData: null,
			bannerSrc: App.pluginPath + 'eros/images/badges/shopvote.png'
		};
	},

	created() {
		this.fetchRatingData();
	},

	computed: {
		ratingPercent() {
			return this.ratingData ? this.ratingData.ratingvalue * 20 : 95;
		},

		rating() {
			return this.ratingData ? this.ratingData.ratingvalue.toFixed(2) + "  / 5 " + TranslationService.translate("Eros::Template.checkoutRatingsVeryGood") : 0;
		},

		ratingCount() {
			return this.ratingData ? this.ratingData.ratingcount + " " + TranslationService.translate("Eros::Template.checkoutRatings") : 0;
		}
	},

	methods: {
		fetchRatingData() {
			ApiService.get("https://widgets.shopvote.de/allvotes-v2.php?shopid=" + this.shopId + "&fcode=9fb70eb163&type=2&src=https&lang=" + App.language)
				.done(response => {
					this.ratingData = response;
				});
		}
	}
};
</script>